export default "__VITE_PUBLIC_ASSET__ded0dbb1__"